import React, { useState, useEffect } from 'react';

const BackToTopButton = () => {
    const [isVisible, setIsVisible] = useState(false);

    const scrollFunction = () => {
        if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    const scrollToTop = () => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    };

    useEffect(() => {
        window.addEventListener('scroll', scrollFunction);
        return () => {
            window.removeEventListener('scroll', scrollFunction);
        };
    }, []);

    const buttonStyle = {
        position: 'fixed',
        bottom: '20px',
        right: '36px',
        display: isVisible ? 'block' : 'none',
        zIndex: 999,
        cursor: 'pointer',
    };

    const circle = {
        filter: 'url(#shadow)',
    };

    return (
        <div
            style={buttonStyle}
            onClick={scrollToTop}
            title="Go to top"
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {if(e.key === 'Enter') { scrollToTop() }}}>
            <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none" style={circle}>
                <filter id='shadow' colorInterpolationFilters="sRGB">
                    <feDropShadow dx="0" dy="4" stdDeviation="1.5" floodOpacity="0.2" />
                </filter>
                <circle cx="40" cy="40" r="40" id="circle" fill="white"  />
                <svg xmlns="http://www.w3.org/2000/svg" width='100%' height='100%' viewBox="-21 -21 67 67" fill="none">
                    <path d="M5 3.75C5 3.33579 5.33579 3 5.75 3H18.25C18.6642 3 19 3.33579 19 3.75C19 4.16421 18.6642 4.5 18.25 4.5H5.75C5.33579 4.5 5 4.16421 5 3.75Z" fill="#0074C8" />
                    <path d="M12.5303 6.21967L17.7803 11.4697C18.0732 11.7626 18.0732 12.2374 17.7803 12.5303C17.4752 12.8354 17.0272 12.7959 16.7196 12.5303L12.7499 8.56V21.25C12.7499 21.6795 12.4055 21.9727 11.9999 22C11.5704 22 11.2772 21.6556 11.2499 21.25V8.56L7.28026 12.5303C7.01399 12.7966 6.59733 12.8208 6.30372 12.6029L6.2196 12.5303C5.91453 12.2253 5.95407 11.7772 6.2196 11.4697L11.4696 6.21967C11.7359 5.9534 12.1525 5.9292 12.4461 6.14705L12.5303 6.21967Z" fill="#0074C8" /></svg>
            </svg>
        </div>
    );
};

export default BackToTopButton;